import * as React from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Button, Stack, Typography } from '@mui/material';
import { updatePasswordSchema } from '../../../app/common/formValidations/validationSchemes';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../app/stores/store';
import { IUseUpdatePasswordFromValue } from '../../../app/models/user';
import { withNavbar } from '../../../app/layout/HOC';

interface State {
    currentPassword: string;
    showCurrentPassword: boolean;
    newPassword: string;
    showNewPassword: boolean;
    confirmPassword: string;
    showConfirmPassword: boolean;
}
const btn = {
    width: '29ch',
    mt: 1,
    ml: 1,
    // bgcolor: '#234f1e',
    // '&:hover': {
    //     backgroundColor: '#234f1e',
    //     opacity: [0.9, 0.8, 0.7],
    // },
}
function ChangePassword() {
    const [values, setValues] = React.useState<State>({
        currentPassword: '',
        showCurrentPassword: false,
        newPassword: '',
        showNewPassword: false,
        confirmPassword: '',
        showConfirmPassword: false
    });

    const [passwordError, setPasswordError] = React.useState(false);

    const { userStore } = useStore();
    const { changeUserPassword, loading, isPasswordChangeSuccess } = userStore;

    React.useEffect(() => {
        if (!loading && isPasswordChangeSuccess) {
            resetState();
        }
    }, [isPasswordChangeSuccess, loading]);

    const handleChange =
        (prop: keyof State) => (event: React.ChangeEvent<HTMLInputElement>) => {
            setValues({ ...values, [prop]: event.target.value });
        };

    const handleClickShowCurrentPassword = () => {
        setValues({
            ...values,
            showCurrentPassword: !values.showCurrentPassword,
        });
    };
    const handleClickShowNewPassword = () => {
        setValues({
            ...values,
            showNewPassword: !values.showNewPassword,
        });
    };
    const handleClickShowConfirmPassword = () => {
        setValues({
            ...values,
            showConfirmPassword: !values.showConfirmPassword,
        });
    };

    const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
    };

    const resetState = () => {
        const newState: State = {
            currentPassword: '',
            showCurrentPassword: false,
            newPassword: '',
            showNewPassword: false,
            confirmPassword: '',
            showConfirmPassword: false
        };
        setValues(newState);
        setPasswordError(false);
    }
    const submitData = () => {
        updatePasswordSchema.isValid({
            currentPassword: values.currentPassword,
            newPassword: values.newPassword,
            confirmPassword: values.confirmPassword
        }).then(function (valid: any) {
            if (!valid) {
                setPasswordError(true);
            } else {
                setPasswordError(false);
                const uptValues: IUseUpdatePasswordFromValue = {
                    currentPassword: values.currentPassword,
                    newPassword: values.newPassword,
                    confirmPassword: values.confirmPassword
                };

                changeUserPassword(uptValues);
            }
        });
    }

    return (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'column', mt: 15, alignItems: 'center' }}>
            <Stack direction='column' justifyContent="center" alignItems="center">
                <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-current-password">Current Password</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-current-password"
                        type={values.showCurrentPassword ? 'text' : 'password'}
                        value={values.currentPassword}
                        onChange={handleChange('currentPassword')}
                        disabled={loading}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle current password visibility"
                                    onClick={handleClickShowCurrentPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {values.showCurrentPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Current Password"
                    />
                </FormControl>
                <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-new-password">New Password</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-new-password"
                        type={values.showNewPassword ? 'text' : 'password'}
                        value={values.newPassword}
                        onChange={handleChange('newPassword')}
                        disabled={loading}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle new password visibility"
                                    onClick={handleClickShowNewPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {values.showNewPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Current Password"
                    />
                </FormControl>

                <FormControl sx={{ m: 1, width: '25ch' }} variant="outlined">
                    <InputLabel htmlFor="outlined-adornment-confirm-password">Confirm Password</InputLabel>
                    <OutlinedInput
                        id="outlined-adornment-confirm-password"
                        type={values.showConfirmPassword ? 'text' : 'password'}
                        value={values.confirmPassword}
                        onChange={handleChange('confirmPassword')}
                        disabled={loading}
                        endAdornment={
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle confirm password visibility"
                                    onClick={handleClickShowConfirmPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {values.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        }
                        label="Current Password"
                    />
                </FormControl>
                <Button onClick={submitData}
                    // sx={{ width: '29ch', mt: 1, ml: 1 }}
                    sx={btn}
                    disabled={loading}
                    variant="contained">Save</Button>
            </Stack>
            {passwordError &&
                <Stack direction='column' sx={{ border: 1, width: '50ch', mt: 2 }}>
                    <Typography variant='h6' sx={{ color: 'red' }}>Error:</Typography>
                    <Typography variant='body1'>Password should be 12 chars minimum.</Typography>
                    <Typography variant='body1'>Password must contain 1 uppercase and lower letter.</Typography>
                    <Typography variant='body1'>Password must contain a number.</Typography>
                    <Typography variant='body1'>Password must contain non alphanumeric (@, #, $ % etc).</Typography>
                    <Typography variant='body1'>New and confirm password must match.</Typography>
                </Stack>
            }
        </Box>
    );
}

const ChangePasswordPage = withNavbar(observer(ChangePassword));
export default ChangePasswordPage;
